import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { RolBasic } from 'src/app/models/roles-models/rol-basic.model';
import { Center } from 'src/app/models/center-model/center.model';
import { UserService } from 'src/app/services/user-service/user.service';
import { Subscription } from 'rxjs';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';

@Component({
  selector: 'app-users-user-new-role-creation-card',
  templateUrl: './users-user-new-role-creation-card.component.html',
  styleUrls: ['./users-user-new-role-creation-card.component.scss']
})
export class UsersUserNewRoleCreationCardComponent implements OnInit {

  @Input() user;
  @Input() centers;
  @Input() roles;
  selectedCenters;
  showButton: boolean;
  updateUserPermissionsSubscriptions: Subscription;
  basicDataForm = new FormGroup({
    selectedRole: new FormControl(null, Validators.required)
  });

  constructor(private userService: UserService,
              private router: Router,
              private activatedRoute: ActivatedRoute,
              private snackbarService: SnackBarService,
              private userStorageService: UserStorageService) {
                this.showButton = true;
                this.selectedCenters = new Array<Center>();
  }

  ngOnInit() {
  }

  public addNewPermission() {
    const validation = this.validateForm();
    if (validation === true) {
      const permissions = this.user.PermissionList;
      this.selectedCenters.forEach(
        (c) => {
          const permission = new RolBasic();
          permission.CenterInternalId = c.InternalId;
          permission.CenterName = c.CenterName;
          permission.RoleInternalId = this.basicDataForm.get('selectedRole').value.RoleInternalId;
          permission.RoleName = this.basicDataForm.get('selectedRole').value.Rolename;
          permissions.push(permission);
        }
      );
      this.updateUserPermissionsSubscriptions = this.userService.updateUserPermissions(this.user.InternalId, this.userStorageService.getCompanyData().CompanyCode, permissions).subscribe(
        (res) => {
          this.snackbarService.open('roles-page.snackbar messages.update role success', 'success');
          this.userService.refreshUser();
        },
        (error) => {
          this.snackbarService.open(error, 'error');
        }
      );
      this.router.navigate(['../../../user', this.user.InternalId], { relativeTo: this.activatedRoute.parent });
    } else {
      this.snackbarService.open(validation, 'error');
    }
  }

  public centersOutputEventReceiver(centers) {
    const aux = new Array();
    for (const d of centers) {
      aux.push(d[1]._data);
    }
    if (aux) {
      this.selectedCenters = aux;
    }
  }

  public validateForm() {
    if (!this.basicDataForm.get('selectedRole').valid) {
      return 'roles-page.snackbar messages.roles required';
    } if (!(this.selectedCenters.length > 0)) {
      return 'roles-page.snackbar messages.centers required';
    } else {
      return true;
    }
  }

  public setPreselected(op1, op2) {
    if (op1 && op2) {
      return op1.InternalId === op2.InternalId;
    }
  }

  public cancelPermission() {
    this.router.navigate(['../../../user', this.user.InternalId], { relativeTo: this.activatedRoute.parent });
  }
}
